import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { processItemResponse, processResponse, openEndStringFormat } from '../../../../../utilities/processResponse';



class OpenEndedResponse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            charCount:0,
            totalChar:500,
            responseValue:"",
            isType:false
        };

        this.reviewPage = this.props.questionItemList || [];
        this.tempResponse = [];
        this.tempItemList = [];
        this.dataGuidId = null;
        this.isUpdateResponse = false;
    }

    static getDerivedStateFromProps(props, state) {
        const { getAllItemResponse, items, getAllItemResponseForMultiple, ratees, rateeKey } = props;
        const { itemResponseSets } = getAllItemResponse;

        for (const key in itemResponseSets) {
            if (itemResponseSets.hasOwnProperty(key)) {
                const tempItemResponseSets = itemResponseSets[key];

                for (const key in getAllItemResponseForMultiple) {
                        if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                            const elementRes = getAllItemResponseForMultiple[key];

                            if (rateeKey !== undefined && key === rateeKey) {
                                const { itemResponseSets } = elementRes;

                                for (const key in itemResponseSets) {

                                    if (Object.hasOwnProperty.call(itemResponseSets, key)) {
                                        const elementItemResponseSets = itemResponseSets[key];

                                        if (elementItemResponseSets.itemKey.toLowerCase() === items.key.toLowerCase()) {

                                            for (const key in elementItemResponseSets.itemResponses) {
                                                if (elementItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                                    const temp = elementItemResponseSets.itemResponses[key];

                                                    var responseValue = temp.openEnd;

                                                    if (state.isType === false) {
                                                        return {
                                                            responseValue:responseValue,
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                }
            }
        }
        return null;
    }

    componentDidMount = () => {
        const { ratees } = this.props;
        if(ratees.length > 1){
            if (this.isUpdateResponse !== true) {
                const { items, activePageKey} = this.props;
                    if (items.requiredIndicator == 2) {
                        //alert("hi");
                        const nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
                        nextButton.disabled = true;
                        nextButton.classList.add("_PageNextButtonDisable");
                    } 
                }
            }
    }
    componentDidUpdate() {
        const { getAllItemResponse, items, getAllItemResponseForMultiple, ratees, rateeKey, configuration, putAllForItemCollection, getResPonsesOnLoad } = this.props;
        const { itemResponseSets } = getAllItemResponse;
        items.isHide = false;


        for (const key in itemResponseSets) {
            if (itemResponseSets.hasOwnProperty(key)) {
                const tempItemResponseSets = itemResponseSets[key];

                for (const key in getAllItemResponseForMultiple) {
                    if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                        const elementRes = getAllItemResponseForMultiple[key];

                        if (key === rateeKey) {
                            const { itemResponseSets } = elementRes;

                            for (const key in itemResponseSets) {

                                if (Object.hasOwnProperty.call(itemResponseSets, key)) {
                                    const elementItemResponseSets = itemResponseSets[key];
                                    const tempItemResponseSets = itemResponseSets[key];

                                    if (elementItemResponseSets.itemKey.toLowerCase() === items.key.toLowerCase()) {

                                        for (const key in tempItemResponseSets.itemResponses) {
                                            if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                                const temp = tempItemResponseSets.itemResponses[key];
                                                const itemList = this.reviewPage[items.reviewPageKey];


                                                for (const key in itemList) {
                                                    if (itemList.hasOwnProperty(key)) {
                                                        const itemRes = itemList[key];

                                                        if (this.state.isType === false) {
                                                            itemRes.isAnswer = temp.openEnd !== null ? true : false;
                                                            itemList[key].isRequired = temp.openEnd !== null ? false : itemRes.isRequired;
                                                            itemRes.itemResponses[tempItemResponseSets.itemKey] = tempItemResponseSets.itemResponses;

                                                            var itemType = configuration.itemType;
                                                            var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};
                                                            processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection, "onLoad");
                                                            if(ratees.length > 1) {
                                                                getResPonsesOnLoad(elementItemResponseSets.itemKey, elementItemResponseSets, rateeKey);
                                                            }

                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

   handleChange = (e, configuration, rateeKey, index) => {
       try {
           const { items, handleItemResponse, itemTempResponses, ratees, putAllForItemCollection } = this.props;
           const { itemTypeProperties } = configuration;
           this.tempResponse[index] = e.target.value;
          // document.getElementsByClassName("App")[0].style.overflow = "hidden";

           this.setState({isType:true, responseValue:e.target.value});

           var strCount = e.target.value.length;

           if (strCount >= itemTypeProperties.maxLength) {
               e.target.value = e.target.value.substring(0, 500);
           } else {
               this.setState({charCount:strCount})
           }
            for (const key in this.reviewPage[items.reviewPageKey]) {

                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {

                    const itemList = this.reviewPage[items.reviewPageKey];
                    var hasDepend = itemList[key].hasDepend;
                    var openEndValue = e.target.value;
                    var itemKey = itemList[key].key;

                    if (itemList[key].key === items.key) {

                        if (openEndValue !== "") {
                            itemList[key].isAnswer = true;
                            itemList[key].isRequired = false;
                        } else {
                            itemList[key].isRequired = itemList[key].requiredIndicator == 2 ? true :false;
                            itemList[key].isAnswer = false;
                        }
                        for (const rKey in ratees) {

                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {

                                    this.dataGuidId = tempRatees.dataCollectionGuid;

                                    itemList[key].itemResponses[itemKey] = [{
                                        "itemType"     : configuration.itemType,
                                        "buttonGroup"  : null,
                                        "sequence"     : 1,
                                        "isNa"         : itemList[key].isNA,
                                        "response"     : null,
                                        "responseValue": null,
                                        "openEnd"      : openEndValue !== "" ? openEndValue : null
                                    }];

                                    var responseSet = this.props.itemTempResponses[itemKey] = {};
                                    var itemResponses = itemList[key].itemResponses[itemKey];
                                    var itemType = configuration.itemType;

                                    processItemResponse(itemKey, responseSet, itemResponses, itemType, this.dataGuidId, putAllForItemCollection,"onChange");
                                    this.handleDependencyRequired(itemKey, hasDepend);
                                }
                            }
                        }

                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                }
            }

            handleItemResponse(items.key, itemTempResponses, "itemChange", this.dataGuidId);

        } catch (error) {
            console.log("Exception:while openEnd item response:_", error.message)
        }
    }

    handleDependencyRequired = (itemKey, hasDepend) => {
        console.log("hasDepend",hasDepend);
        try {
            var test = setTimeout(() => {
            const { pageList, nextPageKey } = this.props;

                var _blockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._block`);
                var _unBlockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._Unblock`);
                const nextButton = document.getElementsByClassName(`_buttonHideClass_${this.props.activePageKey}`)[0];

                for (const key in pageList) {
                    if (Object.hasOwnProperty.call(pageList, key)) {
                        console.log("pageList",pageList);
                        if (pageList[key].itemsOnSamePage == false) {
                            const tempItems = pageList[key].items;

                        for (const key in tempItems) {  
                            if (Object.hasOwnProperty.call(tempItems, key)) {
                                const element = tempItems[key];
                                for (const depKey in _blockElement) {
                                    if (Object.hasOwnProperty.call(_blockElement, depKey)) {
                                        const dataId = _blockElement[depKey].getAttribute('data-id');

                                        if (element.key === dataId) {
                                            element.isHide = false;
                                        }
                                    }
                                }

                                for (const bKey in _unBlockElement) {
                                    if (Object.hasOwnProperty.call(_unBlockElement, bKey)) {
                                        const dataIdUnblock = _unBlockElement[bKey].getAttribute('data-id');

                                        if (element.key === dataIdUnblock) {
                                            element.isHide = true;
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        if(hasDepend) {
                            console.log("here");
                            for( const depKey in this.props.dependencies) {
                                this.props.dependencies[depKey].map((dep) => {
                                    if(itemKey == dep.key){
                                        //alert("hi");
                                        console.log("dep.response",dep.response);
                                        this.props.handleDependentItem(itemKey,dep.response,null)
                                    }
                                });
                            }


                            }
                        }
                    }
                }

                clearTimeout(test);
            }, 0);

        } catch (error) {
        }
    }

    render() {
        const { configuration, rateeKey, items, pageInstrumentConfiguration } = this.props;
        const { itemTypeProperties } = configuration;
        const { openEndStatusFormatStringSectionKey } = items;
        const { sections } = pageInstrumentConfiguration;
        const { responseValue } = this.state;

        const charLen = responseValue !== null ? responseValue.length : 0;
        const openEndRemainingSection = pageInstrumentConfiguration.hasOwnProperty('sections') ? sections[openEndStatusFormatStringSectionKey]:[];
        const totalCharCount = itemTypeProperties.maxLength - charLen || 0;
        const remainingCharacters = totalCharCount;
        const charactersUsed = charLen;
        const totalAllowedCharacters = itemTypeProperties.maxLength;
        const stringFormat =  openEndRemainingSection !== undefined && openEndRemainingSection.hasOwnProperty('content') ? openEndStringFormat(openEndRemainingSection.content, remainingCharacters, charactersUsed, totalAllowedCharacters) : null;

        return (
            <Fragment>
                <Row>
                    <Col md={12}>
                        {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{__html:processResponse(configuration.scalePreSection)}}></div>:null}
                        {configuration.renderingHint === "textbox" ?
                            <input
                                type="text"
                                key={configuration.key}
                                value={responseValue}
                                className={`_WMQ_Word_input ${configuration.className} OpenEnd_${items.key}`}
                                onChange={(event) => this.handleChange(event, configuration, rateeKey)}
                                maxLength={itemTypeProperties.maxLength !== null && itemTypeProperties.maxLength !== undefined ? itemTypeProperties.maxLength:"-1"}
                            ></input>
                            :
                            <>
                                <>
                                    <textarea
                                key={configuration.key}
                                rows={itemTypeProperties.rows}
                                cols={itemTypeProperties.cols}
                                value={responseValue}
                                        className={`_LIS_textarea OpenEnd_${items.key}  ${configuration.className}`}
                                onChange={(event) => this.handleChange(event, configuration, rateeKey)}
                                        onTouchStart={(event) => this.handleChange(event, configuration, rateeKey)}
                                maxLength={itemTypeProperties.maxLength !== null && itemTypeProperties.maxLength !== undefined ? itemTypeProperties.maxLength:"-1"}
                                        aria-required="true"
                                    />
                                </>
                            <div key={openEndRemainingSection !== undefined ? openEndRemainingSection.key:null}
                                className={`_OpenEndStatusFormatStringSection ${openEndRemainingSection !== undefined ? openEndRemainingSection.className:null}`}>
                                    {stringFormat}
                                </div>
                            </>
                        }
                        {configuration.scalePostSection !== null ? <div dangerouslySetInnerHTML={{__html:processResponse(configuration.scalePostSection)}}></div>:null}
                    </Col>
                </Row>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    answeredQuestionCount:state.survey.answeredQuestionCount,
    getAllItemResponse:state.survey.getAllItemResponse,
    getAllItemResponseForMultiple:state.survey.getAllItemResponseForMultiple
});

export default connect(mapStateToProps)(OpenEndedResponse);
